import React from "react";

const Sensitivity = () => {
  return (
    <div className="col-xl-10 col-lg-9 ">
      <div className="problem_desc border-radius-prop margin_top_20 issues_main_page">
        <h2 className="main-title">Post-operative sensitivity</h2>
        <div className="prblm_inner_content d-flex flex-column justify-content-between toothaid_prblm_content">
          <div>
            <p>
              Pain/Sensitivity in the weeks following the placement of a filling
              (restoration).
            </p>
            <p>
              Background information: A filling is placed to repair a cavity
              (hole) in the tooth typically caused by decay or chipping. In some
              cases, the discomfort is simply a reaction to the process of
              repairing the tooth. In other instances, there may be some
              intervention required by the dentist.
            </p>
          </div>
          <div className="types_causes">
            <div className="mt-4 mb-4 main_section_title">
              <h2 className="text-center ">Symptoms and Management</h2>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="causes_box_shadow treatment_detail">
                  <div>
                    <ul className="causes-detail">
                      <li>
                        <span>Pain on biting</span>-The filling may be
                        disrupting the way your teeth normally bite together
                        (e.g. filling is too high). This can be painful to bite
                        down on due to extra pressure on that tooth. This can be
                        adjusted by your dentist.
                      </li>
                      <li>
                        <span>Toothache/sensitivity</span>-Heat produced by the
                        drill used to shape the cavity can cause inflammation of
                        the pulp (the central part of the tooth containing the
                        nerve and blood supply). As a result of this, in the
                        days following your treatment, the tooth may be
                        sensitive to sensations such as hot and cold or from the
                        pressure of biting.Note: sometimes with very deep or old
                        fillings the pulp may be unable to heal, and the pain
                        can get worse over time. In these occasions the tooth
                        will most likely need root canal treatment or extraction
                        to settle the symptoms.
                      </li>
                      <li>
                        <span>
                          Pain from other areas of your jaw (referred pain)
                        </span>
                        -It is common to feel pain in the teeth surrounding the
                        treated tooth. This is due to the anatomy of our nerves
                        in our face and jaws and results in a phenomenon called
                        referred pain. Single nerves provide sensations from
                        multiple areas and therefore signals can get confused by
                        the brain.
                      </li>
                      <li>
                        <span>Sore gums</span>-The gums around the tooth treated
                        can be sore and tender for a few days after treatment,
                        extra bruising can also be present around the area where
                        the anaesthetic was administered
                      </li>
                      <li>
                        <span>Discomfort when chewing</span>-One should try and
                        refrain from chewing on the site of any fillings for up
                        to 24 hours after they have been applied. It can take
                        some time for the mouth to get used to the new bite
                        surface.
                      </li>
                      <li>
                        <span>Electric shock sensation</span>-This is a very rare
                        situation and occurs as a sharp pain, almost like an
                        electric shock, when two teeth with metal surfaces
                        touch. For example, when one tooth has a gold crown, and
                        the tooth above or below it has a silver filling it can
                        create a little electric shock. This typically wears off
                        after a while
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sensitivity;
